import { StorageSet } from '../storage/index';
import { UseCase } from '../UseCase';

export class SetOAuthState implements UseCase<boolean, string | undefined> {
    private storageSet = new StorageSet<string>();

    execute(set = true): string | undefined {
        const state = set ? Date.now().toString() : undefined;
        this.storageSet.execute({ key: 'oauth.state', value: state });
        return state;
    }
}
